import ExportJsonExcel from 'js-export-excel';

class DetailedSurchargesExcel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let tenCorrectsData = this.revisarDetallesRecargos(data);
        option.fileName = 'Detalles de Recargos';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: tenCorrectsData.data,  // Fuente de datos en archivo Excel
                sheetName: 'Detalles de Recargos',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    revisarDetallesRecargos(dataDetails) {
        let dataTable = [];

        //Titulos
        let CasillasTitulos = this.generarTitulos();
        dataTable.push(CasillasTitulos);

        //Admisiones
        for (let i = 0; i < dataDetails.length; i++) {
            let infoDetallada = this.generarInformacionDetallada(dataDetails[i]);
            dataTable.push(infoDetallada);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTitulos() {
        let casillas = {
            '1': "Primer Apellido",
            '2': "Segundo Apellido",
            '3': "Primer Nombre",
            '4': "Segundo Nombre",
            '5': "Número de Documento",
            '6': "Tipo de Documento",
            '7': "Fecha de Atención",
            '8': "Codigo de Validación",
            '9': "Codigo de Autorización",
            '10': "Servicio",
            '11': "Cantidad",
            '12': "Costo",
            '13': "Copago",
            '14': "Neto"
        }
        return casillas;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.apellido1,
            '2': data.apellido2,
            '3': data.primerNombre,
            '4': data.segundoNombre,
            '5': data.num_documento,
            '6': data.tip_documento,
            '7': data.fecha_atencion,
            '8': data.codigo_validacion,
            '9': data.codigo_autorizacion,
            '10': data.servicio,
            '11': data.cantidad,
            '12': data.costo,
            '13': data.copago,
            '14': data.neto
        }
        return casillas;
    }

}

export default new DetailedSurchargesExcel();